import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  tag: {
    base: {
      ...theme.typography.small,
      appearance: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      borderRadius: '10px',
      paddingLeft: theme.settings.spacing.small,
      paddingRight: theme.settings.spacing.small,
      paddingTop: 0,
      paddingBottom: 0,
      border: 'none',
      marginRight: theme.settings.spacing.small,
      height: '20px',
      lineHeight: '20px',
    },

    filled: {
      base: {
        color: 'white',
      },

      primary: {
        backgroundColor: theme.colors.accents.primary,
      },

      secondary: {
        backgroundColor: theme.colors.accents.secondary,
      },

      positive: {
        backgroundColor: theme.colors.accents.positive,
      },

      negative: {
        backgroundColor: theme.colors.accents.negative,
      },

      dark: {
        backgroundColor: '#404e59',
      },
    },

    hollow: {
      base: {
        borderWidth: '1px',
        borderStyle: 'solid',
        lineHeight: '18px',
      },

      primary: {
        borderColor: theme.colors.accents.primary,
        color: theme.colors.accents.primary,
      },

      secondary: {
        borderColor: theme.colors.accents.secondary,
        color: theme.colors.accents.secondary,
      },

      positive: {
        borderColor: theme.colors.accents.positive,
        color: theme.colors.accents.positive,
      },

      negative: {
        borderColor: theme.colors.accents.negative,
        color: theme.colors.accents.negative,
      },

      dark: {
        borderColor: '#404e59',
        color: '#404e59',
      },
    },

    clickable: {
      base: {
        cursor: 'pointer',
        transition: theme.settings.transitions.regular,
      },

      primary: {
        ':hover': {
          borderColor: theme.colors.accents.primaryHover,
          backgroundColor: theme.colors.accents.primaryHover,
          color: 'white',
        },
        ':active': {
          borderColor: theme.colors.accents.primaryActive,
          backgroundColor: theme.colors.accents.primaryActive,
          color: 'white',
        },
      },

      secondary: {
        ':hover': {
          borderColor: theme.colors.accents.secondaryHover,
          backgroundColor: theme.colors.accents.secondaryHover,
          color: 'white',
        },
        ':active': {
          borderColor: theme.colors.accents.secondaryActive,
          backgroundColor: theme.colors.accents.secondaryActive,
          color: 'white',
        },
      },

      positive: {
        ':hover': {
          borderColor: theme.colors.accents.positiveHover,
          backgroundColor: theme.colors.accents.positiveHover,
          color: 'white',
        },
        ':active': {
          borderColor: theme.colors.accents.positiveActive,
          backgroundColor: theme.colors.accents.positiveActive,
          color: 'white',
        },
      },

      negative: {
        ':hover': {
          borderColor: theme.colors.accents.negativeHover,
          backgroundColor: theme.colors.accents.negativeHover,
          color: 'white',
        },
        ':active': {
          borderColor: theme.colors.accents.negativeActive,
          backgroundColor: theme.colors.accents.negativeActive,
          color: 'white',
        },
      },

      dark: {
        ':hover': {
          borderColor: '#404e59',
          backgroundColor: '#404e59',
          color: 'white',
        },
        ':active': {
          borderColor: '#404e59',
          backgroundColor: '#404e59',
          color: 'white',
        },
      },
    },
  },
})
